import { useTranslation } from "react-i18next";
import { PaymentType } from "../../api/types";
import PendingIcon from "../icons/pending.svg?react";
import { Box, Flex, Heading, Text } from "@radix-ui/themes";

export function PaymentPending({
  statusCode,
  paymentType,
}: {
  statusCode?: string;
  paymentType: PaymentType;
}) {
  const noPaperError = statusCode === "NO_PAPER";
  const { t } = useTranslation();

  if (paymentType === PaymentType.App) {
    return (
      <Box className="w-full h-full flex flex-col items-center justify-between p-2 py-12">
        <figure className="flex justify-center mb-4 overflow-hidden">
          <video
            autoPlay
            playsInline
            muted
            loop
            className="scale-150"
            src="/phone-payment-processing-600px.webm"
          />
        </figure>
        <Flex mt="2" gap="4" justify="center" align="center">
          <Heading
            align="center"
            size="6"
            weight="bold"
            color="gray"
            highContrast
          >
            {t("paymentProcessing")}
          </Heading>
        </Flex>
      </Box>
    );
  }

  if (paymentType === PaymentType.Terminal) {
    return (
      <Box className="w-full h-full flex flex-col items-center justify-between p-2 py-8">
        <figure className="flex justify-center aspect-[6/5]">
          <video
            className="object-cover w-full h-full"
            src="/terminal-processing-touchless-600px.webm"
            muted
            autoPlay
            loop
            playsInline
          />
        </figure>
        <Flex gap="4" justify="center" align="center">
          <Heading
            align="center"
            size="6"
            weight="bold"
            color="gray"
            highContrast
          >
            {t("terminalPending")}
          </Heading>
        </Flex>
      </Box>
    );
  }

  return (
    <Box>
      <div className="w-full h-full flex flex-col items-center justify-center">
        {noPaperError ? (
          <PendingIcon color="#BA5900" />
        ) : (
          <PendingIcon color="#0094FF" />
        )}
        <Heading size="6" mb="4" mt="2" weight="bold" color="gray" highContrast>
          {t("paymentPending")}
        </Heading>
        {noPaperError && (
          <>
            <Text mb="1" size="6" align="center">
              {t("posAttention")}
            </Text>
            <Text mb="3" size="2" align="center">
              {t("statusCode")}: {statusCode}
            </Text>
          </>
        )}
      </div>
    </Box>
  );
}
